// extracted by mini-css-extract-plugin
export default {"container":"ConfirmDelete_container__G2G6M","icon":"ConfirmDelete_icon__kSBvr","text":"ConfirmDelete_text__o7ivS","footer":"ConfirmDelete_footer__ikI8c"};